import getPipeValue from './getPipeValue';

const isSpecialPlateAllowed = (pipe) => {
  if (!pipe) {
    // return false;
    // Testing line below for original plate fees with specialty plates to unlock if a vehicle is not chosen
    return Number(getPipeValue(pipe, 'r20')) !== 2;
  }
  // Special plates are not allowed if personal plates are
  // not allowed, and personal plates are not allowed when a
  // vehicle's pipestring value of r20 === 2.
  return Number(getPipeValue(pipe, 'r20')) !== 2;
};

export default isSpecialPlateAllowed;
